<template lang="pug">
      div.list-wrapper
          div.list-element(
            v-if="!gameStarted"
            v-for="(itemsArray, index) in groupedCorrectAnswersArrayOfRows"
            :class="{ 'dynamic-list_height_7': isMoreThanSevenItemsInRoom, 'dynamic-list_height_5-7': isBetweenFiveAndSevenItemsInRoom }"
            )
              div.list-element__number
                  |  {{ index + 1 }}
              div.list-element__words(
                v-for="item in itemsArray"
                :class="{'dynamic-words_font-size': isMoreThanTwoWords, 'dynamic-words_size_for_one': isOnlyOneWord}"
                )
                  div.list-element__word
                      | {{ item.value }}
          div.answer-elements(v-if="gameStarted")
              div.answer-number
                  | {{ answersForEachTurn.index + 1 }}
              div.answer-choices(v-for="item in answersForEachTurn.arrays")
                  cs-button.answer-choice(
                    color="white"
                    @click="chooseElement(item)"
                    :class="{'dynamic-answers_size': isAnswerItemsMoreThanFive, 'chosen-element': item.checked, 'wrong-choice': isWrongAnswer(item)}"
                    :disabled="isWrongAnswer(item)"
                    )
                      | {{ item.value }}
              cs-button.list__button(
                color="blue"
                @click="checkAnswers"
                :disabled="!isDisableNextTurnButton"
                )
                  | {{ $i18n.t('olympiads.olympiads_processStage_further') }}
</template>

<script>
    export default {
        props: {
            answersForEachTurn: Object,
            groupedCorrectAnswersArrayOfRows: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            arrayOfAnswers: Array,
            gameStarted: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {};
        },
        methods: {
            checkAnswers() {
                this.$emit('checkAnswers');
            },
            chooseElement(item) {
                this.$emit('chooseElement', item);
            },
            isWrongAnswer(item) {
                return item.verified && !item.checked && !item.isCorrect;
            },
        },
        computed: {
            isDisableNextTurnButton() {
                let i = 0;
                this.answersForEachTurn.arrays.forEach(item => {
                    item.checked && i++;
                });
                return i === this.answersForEachTurn.arrays.length / 2;
            },
            isBetweenFiveAndSevenItemsInRoom() {
                return (
                    this.groupedCorrectAnswersArrayOfRows.length > 5 &&
                    this.groupedCorrectAnswersArrayOfRows.length <= 7
                );
            },
            isMoreThanSevenItemsInRoom() {
                return this.groupedCorrectAnswersArrayOfRows.length > 7;
            },
            isMoreThanTwoWords() {
                return this.groupedCorrectAnswersArrayOfRows[1].length > 2;
            },
            isOnlyOneWord() {
                return this.groupedCorrectAnswersArrayOfRows[1].length === 1;
            },
            isAnswerItemsMoreThanFive() {
                return this.answersForEachTurn.arrays.length > 4;
            },
        },
    };
</script>

<style lang="scss" scoped>
    .wrong-choice {
        border: 2px solid red !important;
    }
    .list__button {
        width: 170px;
        height: 50px;
        margin-top: 35px;
    }
    .list-element {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        height: 100px;
        @include media($lg) {
            width: 350px;
        }
    }
    .dynamic-list_height_5-7 {
        height: 65px;
        @include media($xl) {
            height: 85px;
        }
    }
    .dynamic-list_height_7 {
        height: 55px;
        @include media($xl) {
            height: 70px;
        }
    }
    .list-element:nth-child(odd) {
        background-color: white;
    }
    .list-element__number {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 25px;
        margin-left: 10px;
        margin-right: 10px;
        @include media($lg) {
            margin-right: 0;
        }
        @include media($xl) {
            font-size: 25px;
            margin-left: 15px;
        }
    }
    .list-element__words {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        font-size: 20px;
        @include media($xl) {
            font-size: 25px;
        }
    }
    .dynamic-words_size_for_one {
        margin-left: 60px;
        font-size: 25px;
    }
    .dynamic-words_font-size {
        font-size: 15px;
        @include media($xl) {
            font-size: 20px;
        }
    }
    .list-element__word {
        margin-left: 15px;
        @include media($xl) {
            margin-left: 20px;
        }
    }

    .answer-elements {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        @include media($lg) {
            width: 300px;
        }
    }
    .answer-number {
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid hsl(121, 38%, 58%);
        border-radius: 50%;
        width: 50px;
        height: 50px;
        font-weight: 700;
        font-size: 25px;
        margin-top: 15px;
        margin-bottom: 20px;
    }
    .answer-choices {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .answer-choice {
        margin-top: 30px;
        color: black;
        width: 230px;
        height: 60px;
        font-size: 20px;
        border-radius: 5px;
        border: 2px solid #bdbdbd;
        &:hover {
            background-color: white;
            border: 2px solid #2187ff;
        }
    }
    .chosen-element {
        border: 2px solid #2187ff;
    }
    .dynamic-answers_size {
        height: 50px;
        margin-top: 15px;
    }
</style>
